import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import { ScreenStates } from "../../../components/LandingTemplates/test_proverki_skorosti_chteniya";

const TITLE = 'Онлайн-тест проверки скорости чтения и понимания прочитанного | Центр образовательных технологий Advance';
const DESCRIPTION = 'Онлайн-тест проверки скорости чтения и понимания прочитанного от центра образовательных технологий Advance';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'89c491061561cd86eb515becec8961378e163be1'} id={'173575'} />) }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <div className="container">
      <HeaderLogoAndTel/>
    </div>

    <main>
      <ScreenStates widget={widget} />
    </main>

    <FooterFull/>
  </DefaultLayout>
);

export default Page;
